export const dateValidation = (value: Date, allValues: Record<string, any>, { source }: any) => {
  if (!value || !source) return undefined;

  const isStart = source.endsWith("start_date");
  const isEnd = source.endsWith("end_date");
  const prefix = source.replace(isStart ? "_start_date" : "_end_date", "");

  const dateValue = new Date(value);

  // Check for missing paired date
  if (isStart && !allValues[`${prefix}_end_date`]) {
    return "You must set the end date if you set the start date";
  }
  if (isEnd && !allValues[`${prefix}_start_date`]) {
    return "You must set the start date if you set the end date";
  }

  // Date must be in the past
  if (dateValue > new Date()) {
    return "The date must be in the past";
  }

  // Check start < end
  if (isStart && allValues[`${prefix}_end_date`]) {
    const endDate = new Date(allValues[`${prefix}_end_date`]);
    if (dateValue > endDate) {
      return "The start date must be before the end date";
    }
  }

  // Check end > start
  if (isEnd && allValues[`${prefix}_start_date`]) {
    const startDate = new Date(allValues[`${prefix}_start_date`]);
    if (dateValue < startDate) {
      return "The end date must be after the start date";
    }
  }

  return undefined;
};
